export enum ERROR_CODE {
  OK = 'OK',
  ERR_UNKNOWN = 'ERR_UNKNOWN',
  ERR_BAD_TOKEN = 'ERR_BAD_TOKEN',
  ERR_BAD_REFRESHTOKEN = 'ERR_BAD_REFRESHTOKEN',
  ERR_BAD_MEDIA_TYPE = 'ERR_BAD_MEDIA_TYPE',
  ERR_BAD_HOSPITALNAME = 'ERR_BAD_HOSPITALNAME',
  ERR_BAD_ORGANIZATION_ID = 'ERR_BAD_ORGANIZATION_ID',
  ERR_BAD_PATIENTID = 'ERR_BAD_PATIENTID',
  ERR_DEVICE_NOT_FOUND = 'ERR_DEVICE_NOT_FOUND',
  ERR_DEVICE_NOT_REGISTERED = 'ERR_DEVICE_NOT_REGISTERED',
  ERR_CLIENT_DEVICE_ALREADY_ASSIGNED = 'ERR_CLIENT_DEVICE_ALREADY_ASSIGNED',
  ERR_HEALTHDOT_USED = 'ERR_HEALTHDOT_USED',
  ERR_BAD_BARCODE = 'ERR_BAD_BARCODE',
  ERR_DEVICE_ALREADY_ASSIGNED = 'ERR_DEVICE_ALREADY_ASSIGNED',
  ERR_PHONE_NUMBER_ALREADY_USED = 'ERR_PHONE_NUMBER_ALREADY_USED',
  ERR_NO_PAIRINGS = 'ERR_NO_PAIRINGS',
  ERR_PATIENT_IN_OTHER_ORG = 'ERR_PATIENT_IN_OTHER_ORG',
  ERR_NO_ACCESS = 'ERR_NO_ACCESS',
  ERR_SERVER = 'ERR_SERVER',
  ERR_NO_ACCESS_TO_ORGANIZATION = 'ERR_NO_ACCESS_TO_ORGANIZATION',
  ERR_CLINICAL_UNIT_ALREADY_EXISTS = 'ERR_CLINICAL_UNIT_ALREADY_EXISTS',
  ERR_CLINICAL_UNIT_NOT_EMPTY = 'ERR_CLINICAL_UNIT_NOT_EMPTY',
  // mobile app added error codes
  ERR_NETWORK = 'ERR_NETWORK',
  ERR_UNAUTHORIZED = 'ERR_UNAUTHORIZED',
  ERR_PORTAL_USER_NOT_FOUND = 'ERR_PORTAL_USER_NOT_FOUND',
}

export const userMessages: Record<string, string> = {
  [ERROR_CODE.ERR_BAD_PATIENTID]:
    'No patient with this ID exists in your organization. Please scan or enter an existing patient ID.',
  [ERROR_CODE.ERR_NO_ACCESS]:
    'You are not authorized to add patients. Please contact your local administrator.',
  [ERROR_CODE.ERR_DEVICE_NOT_FOUND]:
    'The scanned device is unknown or does not belong to this organization. Please inform your local administrator and use another device.',
  [ERROR_CODE.ERR_DEVICE_NOT_REGISTERED]:
    'The scanned device is not registered in the system. Please use another device or inform your local administrator.',
  [ERROR_CODE.ERR_CLIENT_DEVICE_ALREADY_ASSIGNED]:
    'This Healthdot is already assigned to another patient and can not be used again.',
  [ERROR_CODE.ERR_HEALTHDOT_USED]:
    'This Healthdot has been used and cannot be used again. Please use another Healthdot.',
  [ERROR_CODE.ERR_BAD_BARCODE]:
    'The scanned code is not from a valid device. Scan the code on the viQtor or Healthdot device.',
  [ERROR_CODE.ERR_DEVICE_ALREADY_ASSIGNED]:
    'The selected device is already assigned to a patient. Please release it first and try again.',
  [ERROR_CODE.ERR_PHONE_NUMBER_ALREADY_USED]:
    'This phone number is already used by another patient. Please enter a different phone number.',
  [ERROR_CODE.ERR_SERVER]:
    'A technical error occurred. Please try again later. If the problem persists, contact your local administrator.',
  [ERROR_CODE.ERR_NETWORK]: 'Failed to connect. Check your internet connection and try again.',
  [ERROR_CODE.ERR_UNAUTHORIZED]:
    'You are not authorized to use this application with this user account. Please contact your local administrator.',
  [ERROR_CODE.ERR_BAD_REFRESHTOKEN]: 'Your session has expired. Please login again.',
  [ERROR_CODE.ERR_UNKNOWN]:
    'An unknown error occurred. Please try again later. If the problem persists, contact your local administrator.',
};

export class AppError extends Error {
  code: string;
  translationCode: string;
  userMessage?: string;

  constructor(code = ERROR_CODE.ERR_UNKNOWN, message = userMessages[ERROR_CODE.ERR_UNKNOWN]) {
    super(message);

    this.code = code;
    this.translationCode = userMessages[this.code] ? this.code : ERROR_CODE.ERR_UNKNOWN;
    this.userMessage = userMessages[this.translationCode];

    Object.setPrototypeOf(this, new.target.prototype);
  }
}
